__turbopack_context__.v({
  "gallery": "_8TlpRW_gallery",
  "gallery--3": "_8TlpRW_gallery--3",
  "gallery--4": "_8TlpRW_gallery--4",
  "gallery--6": "_8TlpRW_gallery--6",
  "imageWrapper": "_8TlpRW_imageWrapper",
  "lightboxImage": "_8TlpRW_lightboxImage",
  "lightboxImageWrapper": "_8TlpRW_lightboxImageWrapper",
  "lightboxPortal": "_8TlpRW_lightboxPortal",
});
